import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route's pathname changes.
 * Without this, React Router preserves the scroll position across SPA
 * navigations, so clicking a footer link (at the bottom of the page) would
 * land you at the bottom of the next page.
 *
 * Skips when there's a #hash so in-page anchor scrolling (e.g. the Podcast
 * page jumping to a section) still works.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
